import React from 'react';
import { Dashboard } from '../sections/dashboard/dashboard';
import { Data } from '../sections/data/data';
import { Analitycs } from '../sections/analytics/analytics';
import { Contact } from '../sections/contact/contact';
import { Information } from '../sections/information/information';
import { Input } from '../components/form/inputs/input/input';
import { Textarea } from '../components/form/inputs/textarea/textarea';
import { Select } from '../components/form/inputs/select/select';
import { DatePicker } from '../components/form/inputs/datepicker/datepicker';

export default {
  routes: [
    { path: '*', element: <Dashboard /> },
    { path: '/analitycs', element: <Analitycs /> },
    { path: '/data', element: <Data /> },
    { path: '/info', element: <Information /> },
    { path: '/contact', element: <Contact /> },
  ],
  menuLinks: [
    { name: 'Dashboard', path: '/', icon: 'house' },
    { name: 'Analisis', path: '/analitycs', icon: 'chart-pie' },
    { name: 'Datos', path: '/data', icon: 'database' },
    { name: 'Contacto', path: '/contact', icon: 'address-book' },
    { name: 'Informacion', path: '/info', icon: 'users' },
  ],
  filters: [
    { Component: Select, label: 'Ubicacion y hora', items: [
      { label: 'Empresa Grupo Técnico Basse Ltda', values: ['8 AM', '12 PM', '5:00 PM'], dates: ['08:00:00.000Z', '12:00:00.000Z', '17:00:00.000Z'] },
      { label: 'Pruebas Piloto Portal Suba', values: ['8 AM', '12 PM', '6 PM'], dates: ['08:00:00.000Z', '12:00:00.000Z', '18:00:00.000Z'] },
      { label: 'Pruebas Piloto Parqueadero Plaza Imperial', values: ['8 AM', '12 PM', '6 PM'], dates: ['08:00:00.000Z', '12:00:00.000Z', '18:00:00.000Z'] }
    ], type: 'select', variable: 'location'   
    },
    { Component: DatePicker, label: 'Rango de fecha', type: 'datepicker', variable: 'date' }
  ],
  contactFields: [
    { Component: Input, label: 'Dinos tu nombre', placeholder: 'Nombre', span: '1' },
    { Component: Input, label: 'Apellido', placeholder: 'Apellido', span: '1' },
    { Component: Input, label: 'Escribe tu correo electronico', placeholder: 'Correo electronico' },
    { Component: Input, label: 'Escribe tu numero de contacto', placeholder: 'Celular' },
    { Component: Textarea, label: 'Escribe tu numero de contacto', placeholder: 'Celular', rows: 6 }
  ],
  api: {
    url: process.env.REACT_APP_API_URL || 'https://epca.lucaspalencia.dev/samples'
  },
};
